import axios from 'axios';
// import { getNewTokens } from './Api';
// import { getCookie, setCookie } from '@helper/functions';

const baseUrl = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: `${baseUrl}`,
  withCredentials: true,
});

// api.interceptors.request.use(
//   (config) => {
//     const token = getCookie('accessToken');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (err) => Promise.reject(err),
// );

// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       const res = await getNewTokens();

//       if (!res) {
//         if (window.location.pathname !== '/login') {
//           window.location.replace('/login');
//         }
//         return;
//       }

//       setCookie('accessToken', res, 1);

//       return api(originalRequest);
//     }
//     return Promise.reject(error);
//   },
// );

export default api;
